export const februaryAbbreviatedLowercase = "EACPMc";
export default {februaryAbbreviatedLowercase};